export default __webpack_public_path__ + "f9394a5712169c3788a1cf482d257eb6.svg";